module.exports = __webpack_public_path__ + "media/tacet-acronym-video.dfddf219.mp4";